var map = {
	"./Autometrics.pdf": "./src/assets/video/Autometrics.pdf",
	"./Sample - 1.pdf": "./src/assets/video/Sample - 1.pdf",
	"./Sample - 2.pdf": "./src/assets/video/Sample - 2.pdf",
	"./Sample - 3.pdf": "./src/assets/video/Sample - 3.pdf",
	"./Sample - 4.pdf": "./src/assets/video/Sample - 4.pdf",
	"./Sample.pdf": "./src/assets/video/Sample.pdf",
	"./auth-bg.mp4": "./src/assets/video/auth-bg.mp4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/video sync recursive ^\\.\\/.*$";